import {MaybeEmpty, productCategory} from "./productTypes";
import {CartAPI, CartOrder} from "./cartTypes";
import {CheckoutFormType} from "../Components/Checkout/CheckoutForm";

export const roomCategories = ["Kitchen", "Vanity", "Build In Closet", "Leather Closet", "RTA Closet", "Cabinet System Closet"] as const;
export const golaTypeNames = ['Regular Kitchen', 'Handless Kitchen', 'Regular Vanity', 'Gola Vanity'] as const;
export const golaNames = ['Aluminum Gola', 'Black Matte Gola', 'White Gloss Gola', 'Champagne Gola', 'Wood Gola'] as const;
export const doorTypesNames = ['No Doors', 'Standard Size Shaker', 'Slab', 'Three Piece Door', 'Five Piece Shaker', 'Finger Pull', 'Shaker', 'Slatted', 'Custom Painted', 'Wood ribbed doors'] as const;
export const finishNames = ['No Doors No Hinges', 'Milino', 'Syncron', 'Luxe', 'Ultrapan PET', 'Zenit', 'Ultrapan Acrylic', 'Slab', 'Frame 3/4', 'Frame 1', 'Frame 1 1/2', 'Frame 2', 'Frame 2 1/2', 'Ribbed', 'Maple', 'Birch', 'White Oak', 'Walnut', 'Clear Coat Maple', 'Clear Coat Birch', 'Clear Coat White Oak', 'Clear Coat Walnut', 'Wood Veneer', 'Finsa', 'Egger', 'Cleaf', 'OneSkin', 'StyleLite'] as const;
export const boxMaterialNames = ['White Melamine', 'Gray Melamine', 'Gray Linen Melamine', 'Beige Linen Melamine', 'Ash Melamine', 'Walnut Melamine', 'Brown Oak', 'Glacier Oak', 'Ivory Woodline', 'Sable Wood', 'Grey Woodline', 'White Oak', 'Desert Oak', 'Natural Plywood', 'White Plywood', 'Gray Plywood', 'Ultra Matte White', 'Ultra Matte Grey', 'Ultra Matte Cashmere', 'Ultra Matte Gris', 'Ultra Matte Volcano', 'White Gloss','Finsa', 'Egger', 'Cleaf', 'OneSkin'] as const;
export const leatherBoxMaterialNames = ['Milino', 'Syncron', 'Luxe', 'Ultrapan PET', 'Zenit', 'Ultrapan Acrylic', 'Wood Veneer', 'StyleLite'] as const;
export const totalBoxMaterialNames = [...boxMaterialNames, ...leatherBoxMaterialNames] as const;
export const grooveNames = ['1/4 rounded', '1/4 squared', '3/4 squared'] as const;
export const rodNames = ["Oval Chrome (Default)", "Matte Black", "Satin Brass", "Satin Chrome", "Satin Nickel"] as const;

export type RoomCategoriesType = typeof roomCategories[number];
export type GolaTypesType = typeof golaTypeNames[number];
export type GolaType = typeof golaNames[number];
export type DoorTypesType = typeof doorTypesNames[number];
export type FinishTypes = typeof finishNames[number];
export type BoxMaterialType = typeof totalBoxMaterialNames[number];
export type GrooveType = typeof grooveNames[number];
export type RodType = typeof rodNames[number];

export interface RoomMaterialsFormType {
    category: MaybeEmpty<RoomCategoriesType>,
    door_type: MaybeEmpty<DoorTypesType>,
    door_finish_material: MaybeEmpty<FinishTypes>,
    box_material: MaybeEmpty<BoxMaterialType>,
    box_color: string,
    drawer_brand: string,
    drawer_type: string,
    drawer_color: string,
    leather: string,
    rod: MaybeEmpty<RodType>
    name: string,
    category_gola_type: MaybeEmpty<GolaTypesType>
    gola: MaybeEmpty<GolaType>,
    door_frame_width: string,
    door_color: string,
    door_grain: string,
    leather_note: string,
    groove: MaybeEmpty<GrooveType>,
}

export interface RoomNewType extends RoomMaterialsFormType {
    purchase_order_id: string,
    category: RoomCategoriesType,
}

export interface RoomType extends RoomNewType {
    _id: string
}

export interface RoomFront extends RoomType {
    activeProductCategory: MaybeEmpty<productCategory>,
}

export interface RoomOrderType extends RoomType {
    carts: CartAPI[]
}

export type DataToJSONType = {
    date: string,
    contact: CheckoutFormType,
    rooms: RoomJSONData[]
}

export type RoomJSONData = {
    materials: any,
    orders: CartOrder[]
}

export type OrderFormSelectType = {
    data: materialsData[],
    value: any,
    name: string,
    label?: string
    size?: 'small' | 'large' | 'small-square'
}

export type materialsData = {
    value: string,
    img?: string,
    label?: string,
    outOfStock?: boolean,
    is_hide?: boolean
}

export interface drawer extends materialsData {
    types: drawerType[]
}

export interface drawerType extends materialsData {
    colors: materialsData[]
}

export interface doorType extends materialsData {
    finish: finishType[]
    frame?: materialsData[],
}

export interface finishType extends materialsData {
    colors?: colorType[],
}

export interface colorType extends materialsData {
    isGrain?: boolean | number
}

export type MaterialsType = {
    categories: materialsData[],
    golaType: materialsData[],
    gola: materialsData[],
    doors: doorType[],
    boxMaterial: materialsData[],
    drawers: drawer[],
    leatherBoxMaterial: materialsData[]
    leatherType: materialsData[],
    grain: materialsData[],
    groove: materialsData[],
    rod: materialsData[]
}

export const customPartsImgList = [
    {
        name: "Panel, Filler",
        img: "Panel.jpg"
    },
    {
        name: "Toe Kick",
        img: "Toe Kick.jpg"
    },
    {
        name: "L Shape",
        img: "L-shape.jpg"
    },
    {
        name: "Double Panel",
        img: "Double Panel.jpg"
    },
    {
        name: "Column",
        img: "Column.jpg"
    },
    {
        name: "Open Cabinet",
        img: "Open Cabinet.jpg"
    },
    {
        name: "Floating Shelf",
        img: "Floating Shelf.jpg"
    },
    {
        name: "Shaker Glass Door",
        img: "Shaker Glass.jpg"
    },
    {
        name: "Aluminum Glass Door",
        img: "Alum Glass.jpg"
    },
    {
        name: "Glass Shelf",
        img: "Glass.jpg"
    }
] as const;
export type CustomPartsImgListItemNames = typeof customPartsImgList[number]["name"];
export type CustomPartsImgListItem = {
    name: CustomPartsImgListItemNames,
    img: string
}